export function coverDisplayTitleFromOverlays(cover?: { textOverlays?: unknown }): string {
  const list = cover?.textOverlays;
  if (!Array.isArray(list)) return "";
  for (const item of list) {
    if (item && typeof item === "object" && "content" in item) {
      const c = (item as { content?: unknown }).content;
      if (typeof c === "string" && c.trim()) return c.trim();
    }
  }
  return "";
}
